import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import { UploadMedia } from '../../../../../common/components/common/upload-media';
import EventPlansComponent from './event-info.component';
import { EventsBasicInfoComponent } from './event-basic.component';


export const ProgramComponent = ({ selectedEventValues, id, onFormItemChange, selectedEvents, columnDefs, handleEdit, additionButtons, handleDelete, onInnerBasicFormChange, back, handleFormSubmit,communities,Programs }: any) => {

    const handleInnerMediaFormChange: any = ({ field, value }: any) => {
        onFormItemChange({
            value: value.MediaFiles,
            field: 'MediaFiles',
            idx: '', //not used
        });
    };

    const tabItems = [
        {
            id: 1,
            title: 'Basic-Info',
            component: (
                <EventsBasicInfoComponent
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedEvents={selectedEvents}
                    communities={communities}
                    Programs={Programs}
                
                />
            ),
            isVisible: true,
        },
        {
            id: 2,
            title: 'Media',
            component:
                <UploadMedia
                    handleInnerFormChange={handleInnerMediaFormChange}
                    mediaFilesList={selectedEvents?.MediaMappings?.MediaFiles}
                    ownerTypeId={1007}
                    ownerId={id}
                    folderName={'event'}
                />,
            isVisible: true,
        },
        {
            id: 3,
            title: 'Event Plans',
            component:
                <EventPlansComponent
                    handleDelete={handleDelete}
                    additionButtons={additionButtons}
                    handleEdit={handleEdit}
                    columnDefs={columnDefs}
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedEventValues={selectedEventValues}
                />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default ProgramComponent;
